import { render, staticRenderFns } from "./JvBlog.vue?vue&type=template&id=aa2b851c"
import script from "./JvBlog.vue?vue&type=script&lang=js"
export * from "./JvBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports